import {
    Component,
    ContentChild,
    DestroyRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    TemplateRef,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import { SidebarTitleDirective } from '@obo-common/shared/components/sidebar/sidebarTitle.directive';
import { SidebarContentDirective } from '@obo-common/shared/components/sidebar/sidebarContent.directive';
import { BreakpointObserver } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { ModalService } from '@obo-main/services/modal/modal.service';
import { ModalRef } from '@obo-main/services/modal/modalRef.model';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'shd-sidebar',
    imports: [CommonModule, FontAwesomeModule],
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
    @Input() opened: boolean = false;
    @Input() showBackdrop: boolean = false;
    @Input() position: 'left' | 'right' | 'bottom' = 'right';
    @Output()
    openedChange = new EventEmitter<boolean>();

    public isMobile: boolean = false;
    @ViewChild('sidebarTemplate', { static: true })
    private sidebarTemplate: TemplateRef<any>;
    private readonly SIDEBAR_TRANSITION_DURATION = 200; // ms

    @ContentChild(SidebarTitleDirective)
    titleTpl: SidebarTitleDirective;

    @ContentChild(SidebarContentDirective)
    contentTpl: SidebarContentDirective;

    private modalRef: ModalRef;

    constructor(
        private breakpointObserver: BreakpointObserver,
        private overlay: Overlay,
        private viewContainerRef: ViewContainerRef,
        private modalService: ModalService,
        private destroyRef: DestroyRef
    ) {}

    public ngOnInit(): void {
        this.breakpointObserver
            .observe(['(max-width: 576px)'])
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((state) => {
                this.isMobile = state.matches;
            });
    }

    public toggle(): void {
        if (this.modalRef) {
            this.close();
        } else {
            this.open();
        }
        this.openedChange.emit(this.opened);
    }

    public open() {
        const positionStrategy = this.overlay.position().global();

        const overlayConfig = new OverlayConfig({
            positionStrategy,
            hasBackdrop: true
        });

        this.modalRef = this.modalService.open(this.sidebarTemplate, {
            config: overlayConfig,
            viewContainerRef: this.viewContainerRef,
            closeByBackdropClick: false
        });

        setTimeout(() => {
            this.opened = true;
        });

        this.modalRef.dismissed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.close();
        });
    }

    public close() {
        this.opened = false;
        setTimeout(() => {
            this.modalRef.close();
            this.modalRef = null;
        }, this.SIDEBAR_TRANSITION_DURATION);
    }
}
